<template>
  <div>
    <header-index></header-index>
    <div class="body">
      <div class="title">
        <router-link class="router" to="matting">
          <div class="ts iconfont active" @click="setActive">&#xe774; 一键抠图</div>
        </router-link>
        <router-link class="router" to="matting_pro">
          <div class="ts iconfont" @click="setActive">&#xead0; 智能抠图</div>
        </router-link>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FuncTion',
  data() {
    return {
      taskLogId: ''
    }
  },
  created() {
    // this.getOssUploadToken()
  },
  methods: {
    gohome() {
      this.$router.push({ path: '/index/homepage' })
    },
    setActive(event) {
      const items = document.querySelectorAll('.ts')
      items.forEach(item => {
        item.classList.remove('active')
      })
      event.currentTarget.classList.add('active')
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.router-link-active {
  transition: all 0.5s;
  background-color: @morejoy;
  border-radius: @border_radius;
  // color: @font_white;
}

.router-link-active .ts {
  color: @font_white !important; // 强制覆盖
  background-color: @morejoy;
  border-radius: @border_radius;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.body {
  width: 100vw;
  height: calc(100vh - 95px);
  overflow-y: scroll;
  overflow-x: hidden;
  color: @font_white;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  .title {
    display: flex;
    height: 90px;
    line-height: 76px;
    justify-content: center;
    padding: 10px 30px 10px 30px;

    .router {
      flex: 1;
      text-decoration: none;
      color: @font_gray;
    }

    div {
      flex: 1;
      font-size: 25px;
      text-align: center;
      cursor: pointer;
      border-radius: @border_radius;
      border: 2px solid transparent;

      &:hover {
        border: 2px dashed @morejoy;
        transition: all 0.5s;
      }
    }
  }
}
</style>
